export default class Scale {
    constructor() {
        this.scale = 1; // スケールの初期化
        this.scaleChange = 0.0002; // スケールの変化量
        this.scaleMin = 1; // 最小スケール
        this.scaleMax = 1.1; // 最大スケール
    }

    update() {
        this.scale += this.scaleChange;

        // スケールが範囲外に出たら変化の向きを反転
        if (this.scale > this.scaleMax || this.scale < this.scaleMin) {
            this.scaleChange *= -1;
        }
    }

    draw($starry, ctx) {
        const normalizedScale = (this.scale - this.scaleMin) / (this.scaleMax - this.scaleMin);
        const easedScale = this._easeInOutSine(normalizedScale);
        const targetScale = this.scaleMin + easedScale * (this.scaleMax - this.scaleMin);

        // キャンバスの中心に移動
        ctx.translate($starry.width / 2, $starry.height / 2);

        // イージングを適用したスケールを使用
        ctx.scale(targetScale, targetScale);

        // キャンバスの位置を元に戻す
        ctx.translate(-$starry.width / 2, -$starry.height / 2);
    }

    _easeInOutSine(t) {
        return -(Math.cos(Math.PI * t) - 1) / 2;
    }
}
